import * as React from 'react';

import { PaywallScreens } from '~analytics/types';
import { translate } from '~l10n/client';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function TimeLimitPaywall(props: Props) {
  return (
    <PaywallDialog.Long
      id="time-limit-paywall"
      textAlign="center"
      title={translate('Upgrade to Enable Time Limit')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.LaunchQuizTimeLimit}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[PaywallScreens.LaunchQuizTimeLimit]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Apply time limits to quizzes for more consistent pacing and controlled delivery.'
        )}
      </p>
    </PaywallDialog.Long>
  );
}
